<template>
   <div class="quote-checkout">
      <ul class="quote-checkout-list">
        <slot name="anyDiscounts"></slot>
        <li class="total">
          <span class="name">{{ priceTitle }}</span>
          <span class="price">
            <Loader v-if="totalPriceLoading" />
            <template v-else>
              <span class="without-discount">
                {{$t('qic_qar')}} {{ Number(totalPriceWithoutDiscount).toFixed(0)  | splitNumber }}
              </span>
              {{$t('qic_qar')}} {{ Number(totalPrice).toFixed(0)  | splitNumber }}
            </template>
          </span>
        </li>
        <div class="quote__monthly-desc" v-if="selectedPaymentPlan === paymentPlans[1]">
          {{$t('qic_quote_payment_monthly_desc')}}
        </div>
      </ul>

      <BaseButton @click="onSubmit()">
        {{$t('qic_proceed')}}
      </BaseButton>
      <div class="footer-text">
        {{ footerText }}
      </div>
    </div>
</template>

<script>
import Loader from '../Loader'
export default {
  name: 'QuoteCheckoutSimple',
  props: {
    footerText: { type: String },
    termsHref: { type: String },
    quoteInclusivePrice: { type: Number },
    quoteAdditionalPrice: { type: Number },
    totalPrice: { type: Number },
    totalPriceWithoutDiscount: { type: Number },
    quoteDiscountOnline: { type: Number },
    totalPriceLoading: { type: Boolean },
    paymentPlanSwitch: { type: Boolean, default: false }
  },
  emits: [
    'onPayment',
    'onChangePaymentPlan'
  ],
  components: {
    Loader
  },
  data () {
    return {
      paymentMethod: 0,
      acceptance: true,
      acceptanceError: false,
      selectedPaymentPlan: 'annual',
      paymentPlans: ['annual', 'monthly']
    }
  },
  computed: {
    priceTitle () {
      if (this.selectedPaymentPlan === this.paymentPlans[0]) return this.$t('qic_quote_checkout_total')
      return this.$t('qic_quote_checkout_monthly_payment')
    }
  },
  methods: {
    onSubmit () {
      if (!this.acceptance) {
        this.acceptanceError = true
        return
      }
      this.$emit('onPayment', {
        paymentMethod: this.paymentMethod
      })
    }
  },
  watch: {
    acceptance () {
      this.acceptanceError = false
    },
    selectedPaymentPlan () {
      if (this.selectedPaymentPlan === this.paymentPlans[1]) {
        this.paymentMethod = 1
      }
      this.$emit('onChangePaymentPlan', this.selectedPaymentPlan)
    }
  }
}
</script>

<style lang="scss">
    .without-discount {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-decoration-line: line-through;
      color: rgba(82, 108, 130, 0.8);
      margin: 0 12px;
      @media (max-width: 550px){
        font-size: 14px;
      }
    }
    .discount {
      span.name, span.price{
        color: #18B97D;
      }
    }
    span.price, .ltrPrice{
      direction: ltr;
    }
    .checkbox-error {
      color: red;
    }
    .footer-text {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #1C1C1C;
      margin-top: 24px;
      @media (max-width: 550px){
        font-size: 14px;
        line-height: 24px;
      }
    }
</style>
